import ProveedorManagementPage from '../pages/ProveedorManagementPage'

const routes = [
    { name: 'ProveedorManagementPage', path: '/proveedor-management', component: ProveedorManagementPage },
]

export default routes;
